<!--  -->
<template>
  <div class="shownew">
    <ul class="left" >
      
      <li class="title">人才资讯</li>
      <template v-if="articles && articles.length > 0">
        <li class="item" v-for="(article,index) in articles" :key="index" >    
        <router-link tag="p" :to="`/views/info/${article.plateid}/${article._id}`">{{ article.title }}</router-link> 
        <span>{{ article.addtime|dateFormat }}</span>  
        </li>
      </template>
    </ul>
    <ul class="right">
      <router-link tag="li" to="/inquery" class="btnitem" style="background:url(/static/img/rrencaipc.png);">
        人才测评<span style="color:#FFC424;">证书</span>查询
      </router-link>
    </ul>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data () {
    return {
        articles:[],
        global
    };
  },
  props: {
    plates:Array
  },
  filters: {
    dateFormat: function (date) {
      return date?date.substring(0,10):""
    }
  },
  mounted() {
    let strplate = "";
    for (var i = 0; i < this.plates.length; i++) {
        if(this.plates[i].name=="人才资讯"){
            strplate = this.plates[i]._id;
        }
    }
    this.$axios.get(`/api/articles?plateid=${strplate}&page=1&limit=7&sort=-createdAt`).then(res => {
        if(res.data)
        {
            this.articles=res.data.data;
        }
    });
  }
}
</script>
<style scoped>
.shownew{
  width: 1200px !important;
  margin: 59px auto 0;
  height: 420px;
}
.left{
  height: 258px;
  width: 1200px;
  background-image: url(/static/img/honglan.png);
background-repeat: no-repeat;
background-size: 10px 41px;
background-position: left top;
overflow: hidden;
}
.left .title{
  margin-bottom: 36px;
  box-sizing: border-box;
  width: 1200px;
  height: 41px;
  margin-left:27px;
font-size: 28px;
font-family: PingFang SC;
font-weight: bold;
color: #4462CF;
line-height: 28px;
border-bottom:1px solid #EEEEEF;
}
.left .item{
  position: relative;
  margin-bottom: 36px;
  padding-left:24px;
  width: 1200px;
  box-sizing: border-box;
display: flex;
justify-content: space-between;
}
.left .item::before{
  position: absolute;
  content: "";
  top:4px;
  left: 0px;
  width: 10px;
height: 10px;
background: #4462CF;
border-radius: 50%;
  
}
.left .item p{
  width: 882px;
  height: 18px;
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #333333;
line-height: 18px;
  -webkit-background-clip: text;
  word-break: break-all;
  -webkit-box-orient: vertical;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
}
.left .item span{
height: 18px;
font-size: 18px;
font-family: PingFang SC;
color: #999999;
line-height: 18px;
}
.right{
  margin-top: 53px;
  width: 1200px;
height: 110px;
}
.right .btnitem{
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
  width: 1200px;
  height: 110px;
font-size: 40px;
font-family: PingFang SC;
font-weight: bold;
color: #FFFFFF;
line-height: 120px;
text-align: center;
}
</style>